import React from 'react';
import PropTypes from 'prop-types';

export const SvgLogo = ({ color = '#1D1D1B' }) => (
  <svg x="0px" y="0px" viewBox="0 0 302 56.5" style={{ enableBackground: 'new 0 0 302 56.5' }}>
    <g>
      <g>
        <path
          fill={color}
          d="M45.2,34.9h-6.4V0.5H0v38.8h34.4v6.4c0,6,4.8,10.8,10.8,10.8S56,51.6,56,45.7S51.1,34.9,45.2,34.9L45.2,34.9z
			 M4.4,34.9v-30h30v30H4.4z M45.2,52.1c-3.5,0-6.4-2.9-6.4-6.4v-6.4h6.4c3.5,0,6.4,2.9,6.4,6.4C51.6,49.2,48.7,52.1,45.2,52.1z"
        />
        <path
          fill={color}
          d="M140.3,0.5h4L161.7,39h-4.6l-4.5-10.1h-20.8L127.3,39h-4.4L140.3,0.5z M150.9,25l-8.7-19.5L133.5,25H150.9z"
        />
        <path
          fill={color}
          d="M174.3,0.8h13.3c12,0,20.3,8.2,20.3,19v0.1c0,10.8-8.3,19.1-20.3,19.1h-13.3V0.8z M178.6,4.8V35h8.9
			c9.7,0,15.8-6.5,15.8-15v-0.1c0-8.5-6.2-15.1-15.8-15.1L178.6,4.8z"
        />
        <path
          fill={color}
          d="M222,0.8h16.4c4.7,0,8.5,1.4,10.9,3.8c1.9,2,3,4.7,2.9,7.5v0.1c0,6.3-4.4,10-10.4,11.1L253.6,39h-5.3
			l-11.1-14.9h-10.9V39H222V0.8z M238,20.3c5.7,0,9.8-3,9.8-7.9v-0.1c0-4.7-3.6-7.5-9.8-7.5h-11.8v15.5H238z"
        />
        <path
          fill={color}
          d="M280.6,0.5h4L302,39h-4.6l-4.5-10.1h-20.8L267.6,39h-4.4L280.6,0.5z M291.2,25l-8.7-19.5L273.8,25H291.2z"
        />
        <path
          fill={color}
          d="M140.3,0.6h4l17.4,38.5h-4.6L152.6,29h-20.8l-4.5,10.1h-4.4L140.3,0.6z M151,25.1l-8.7-19.5l-8.7,19.5H151z"
        />
        <polygon fill={color} points="110.3,39.1 99.2,24.1 93.9,24.1 105,39.1 		" />
        <path
          fill={color}
          d="M73.1,19.9v-0.1C73.1,9.2,81,0,92.6,0S112,9.1,112,19.6v0.1c0,10.5-7.9,19.8-19.5,19.8S73.1,30.4,73.1,19.9z
			 M107.5,19.9v-0.1c0-8.7-6.3-15.8-15.1-15.8s-15,7-15,15.7v0.1c0,8.7,6.3,15.8,15.1,15.8S107.5,28.5,107.5,19.9z"
        />
      </g>
    </g>
  </svg>
);

SvgLogo.propTypes = { color: PropTypes.string };
